import { defineMessages } from '@atlassian/jira-intl';

type Messages = {
	starButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unstarButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	starButtonLabelWithName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unstarButtonLabelWithName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
};

export const messages: Messages = defineMessages({
	starButtonLabel: {
		id: 'navigation-apps-sidebar-nav4-starred.common.star-jira-item-button.star-button-label',
		defaultMessage: 'Add to starred',
		description: 'The text is shown as a label to the star icon button.',
	},
	unstarButtonLabel: {
		id: 'navigation-apps-sidebar-nav4-starred.common.star-jira-item-button.unstar-button-label',
		defaultMessage: 'Remove from starred',
		description: 'The text is shown as a label to the unstar icon button.',
	},
	starButtonLabelWithName: {
		id: 'navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name',
		defaultMessage: 'Add "{name}" to starred',
		description:
			'Used as the alt text for the "add to starred" menu button item. The {name} attribute refers to the name of the entity that should be added to starred. For example, this could be a filter name like "blocked issues" and the full message would be "Add blocked issues to starred".',
	},
	unstarButtonLabelWithName: {
		id: 'navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name',
		defaultMessage: 'Remove "{name}" from starred',
		description:
			'Used as the alt text for the "remove from starred" menu button item. The {name} attribute refers to the name of the entity that should be remove from starred. For example, this could be a filter name like "blocked issues" and the full message would be "Remove blocked issues from starred".',
	},
});
